export interface PlaceAddressDetails {
	formattedAddress: string;
	postcode?: string;
	suburb?: string;
	state?: string;
}

type AddressComponent = google.maps.places.AddressComponent;

/** Ordered fallbacks: first matching component type wins. */
const SUBURB_TYPES = ['locality', 'postal_town', 'sublocality_level_1', 'sublocality', 'administrative_area_level_2'];

function findComponent(components: AddressComponent[], type: string): AddressComponent | undefined {
	return components.find((component) => component.types.includes(type));
}

/**
 * Extracts postcode / suburb / state from a resolved Google Place.
 */
export function parsePlaceAddressDetails(place: google.maps.places.Place): PlaceAddressDetails {
	const components = place.addressComponents ?? [];

	const postcode = findComponent(components, 'postal_code')?.longText ?? undefined;

	const suburb = SUBURB_TYPES.reduce<string | undefined>(
		(found, type) => found ?? findComponent(components, type)?.longText ?? undefined,
		undefined,
	);

	// shortText gives the abbreviation (e.g. "NSW" instead of "New South Wales").
	const state = findComponent(components, 'administrative_area_level_1')?.shortText ?? undefined;

	return {
		formattedAddress: place.formattedAddress ?? '',
		postcode,
		suburb,
		state,
	};
}
